<template>
  <aside
    :class="[
      'dir-sidebar',
      'd-none',
      'd-lg-block',
      { 'is-collapsed': collapsed }
    ]"
  >
    <div class="dir-sidebar-header">
      <template v-if="!collapsed">
        <i class="el-icon-office-building dir-sidebar-icon"></i>
        <span class="dir-sidebar-title">Directorio</span>
      </template>
      <button
        class="dir-sidebar-toggle"
        @click="toggleCollapse"
        :title="collapsed ? 'Expandir' : 'Colapsar'"
      >
        <i
          :class="collapsed ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'"
        ></i>
      </button>
    </div>

    <nav class="dir-sidebar-nav">
      <el-tooltip
        v-for="item in navItems"
        :key="item.key"
        :content="item.label"
        placement="right"
        :disabled="!collapsed"
      >
        <a
          class="dir-sidebar-item"
          :class="{ active: activeTab === item.key }"
          @click="$emit('change-tab', item.key)"
        >
          <i :class="item.icon" class="dir-sidebar-item-icon"></i>
          <span v-if="!collapsed" class="dir-sidebar-item-label">{{
            item.label
          }}</span>
          <span
            v-if="!collapsed && item.count !== null"
            class="dir-sidebar-item-count"
            >{{ item.count }}</span
          >
        </a>
      </el-tooltip>
    </nav>

    <template v-if="!collapsed">
      <div class="dir-sidebar-section-label">Filtros rápidos</div>
      <nav class="dir-sidebar-nav">
        <a
          v-for="filter in filters"
          :key="filter.key"
          class="dir-sidebar-item"
          :class="{ active: activeFilter === filter.key }"
          @click="$emit('change-filter', filter.key)"
        >
          <i :class="filter.icon" class="dir-sidebar-item-icon"></i>
          <span class="dir-sidebar-item-label">{{ filter.label }}</span>
        </a>
      </nav>
    </template>
  </aside>
</template>

<script>
const STORAGE_KEY = "mydessk_sidebar_collapsed";

export default {
  name: "DirectorySidebar",
  props: {
    activeTab: { type: String, default: "business" },
    activeFilter: { type: String, default: "" },
    businessCount: { type: Number, default: 0 },
    contactsCount: { type: Number, default: 0 },
    carriersCount: { type: Number, default: 0 }
  },
  data() {
    return {
      collapsed: localStorage.getItem(STORAGE_KEY) === "true"
    };
  },
  computed: {
    navItems() {
      return [
        {
          key: "business",
          label: "Empresas",
          icon: "el-icon-suitcase",
          count: this.businessCount
        },
        {
          key: "contacts",
          label: "Contactos",
          icon: "el-icon-user",
          count: this.contactsCount
        },
        {
          key: "carriers",
          label: "Transportistas",
          icon: "el-icon-truck",
          count: this.carriersCount
        },
        {
          key: "notifications",
          label: "Notificaciones",
          icon: "el-icon-bell",
          count: null
        }
      ];
    },
    filters() {
      return [
        { key: "recent", label: "Recientes", icon: "el-icon-time" },
        { key: "clients", label: "Clientes activos", icon: "el-icon-check" },
        { key: "providers", label: "Proveedores", icon: "el-icon-box" }
      ];
    }
  },
  methods: {
    toggleCollapse() {
      this.collapsed = !this.collapsed;
      localStorage.setItem(STORAGE_KEY, this.collapsed);
    }
  }
};
</script>

<style lang="scss" scoped></style>
